function CookieService() {
    this.getCookie = function (cookieAlias) {
        return $.cookie(cookieAlias);
    };

    this.setCookie = function (cookieAlias, cookieValue, cookieSettings) {
        $.cookie(cookieAlias, cookieValue, cookieSettings);
    };

    return this;
}

module.exports = new CookieService();
